import { render, staticRenderFns } from "./YoukeliangGaikuangDetail.vue?vue&type=template&id=84aa3d0a&scoped=true&"
import script from "./YoukeliangGaikuangDetail.vue?vue&type=script&lang=js&"
export * from "./YoukeliangGaikuangDetail.vue?vue&type=script&lang=js&"
import style0 from "./YoukeliangGaikuangDetail.vue?vue&type=style&index=0&id=84aa3d0a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84aa3d0a",
  null
  
)

export default component.exports